import { render, staticRenderFns } from "./publish-ortho-tags.vue?vue&type=template&id=40c35610&scoped=true&"
import script from "./publish-ortho-tags.vue?vue&type=script&lang=js&"
export * from "./publish-ortho-tags.vue?vue&type=script&lang=js&"
import style0 from "./publish-ortho-tags.vue?vue&type=style&index=0&id=40c35610&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "40c35610",
  null
  
)

export default component.exports